import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDiscussions } from "../../hooks/community/useDiscussions";
import { LoaderOverlay } from "../../hooks/loader/LoaderOverlay";
import { CommunityBanner } from "./components/CommunityBanner";
import { CommunityList } from "./components/CommunityList";
import { CommunityTagList } from "./components/CommunityTagList";
import { CommunityToolbar } from "./components/CommunityToolbar";
import { CommunitySection } from "./enums/CommunitySection";
import Pagination from "../components/Pagination";

const CommunityListPage = () => {
    const history = useHistory();
    const [sectionSelected, setSectionSelected] = useState<CommunitySection>(CommunitySection.openDiscussions);
    const [search, setSearch] = useState<string>('');
    const [tagSelected, setTagSelected] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 10;

    const { loading, data } = useDiscussions(sectionSelected, search, currentPage, limit);
    const list = data?.results || [];

    const filteredList = useMemo(() => {
        return list.filter(s => tagSelected && s.tags.includes(tagSelected));
    }, [list, tagSelected]);

    useEffect(() => {
        setCurrentPage(1);
    }, [sectionSelected, search]);

    useEffect(() => {
        document.body.classList.add('community-wrapper')
        return () => document.body.classList.remove('community-wrapper')
    }, []);

    const _handleStartDiscussion = () => {
        history.replace(`/community/new${sectionSelected ? `?type=${sectionSelected}` : ""}`);
    }

    const totalPages = data ? Math.ceil(data.count / limit) : 1;

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <LoaderOverlay visible={loading} message={'Loading...'} />
            <div className="d-flex flex-column align-items-center" style={{ gap: 'var(--External-Marging, 60px)' }}>
                <CommunityBanner
                    onStartDiscussion={_handleStartDiscussion}
                />
                <div className="community-list">
                    <div className="help-center-sections w-100 tap-flex-center justify-content-start">
                        <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={() => history.goBack()}>
                            Back
                        </div>
                    </div>
                    <CommunityToolbar
                        sectionSelected={sectionSelected}
                        onSectionSelect={setSectionSelected}
                        search={search}
                        setSearch={setSearch}
                    />
                    <CommunityTagList
                        list={list}
                        selectedTag={tagSelected}
                        onSelectTag={setTagSelected}
                    />
                    <CommunityList
                        sectionSelected={sectionSelected}
                        list={filteredList}
                        onEnter={(id) => history.replace(`/community/details/${id}`)}
                        onEdit={(id) => history.replace(`/community/edit/${id}?type=${sectionSelected}`)}
                        onArchive={() => { }}
                        onCreateDiscussion={_handleStartDiscussion}
                    />
                    {list.length > 0 && data && (
                        <div className="tap-flex-center mt-5">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default CommunityListPage;